import React from 'react'
import styled from 'styled-components'

import { Heading1, Heading3, Heading5, Paragraph } from '../../styles/Text'

const Heading = styled(Heading1)`
  margin-bottom: 16px;
`

const Text = styled(Paragraph)`
  margin-bottom: 48px;
`

const Subheading = styled(Heading3)`
  margin-bottom: 24px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  column-gap: 30px;
  row-gap: 40px;
  flex-wrap: wrap;
  margin-bottom: 40px;
`

const Item = styled.button`
  display: block;
  text-align: left;
  width: 100%;
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    width: calc(50% - 15px);
  }
`

const ItemImg = styled.img`
  width: 100%;
  margin-bottom: 16px;
`

const ItemHeading = styled(Heading5)`
  margin-bottom: 16px;
  font-weight: 500;
`

const ItemLink = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  svg {
    margin-left: 4px;
  }
`

const Introduction = ({ setCurrentSection }) => {
  return (
    <>
      <Heading>Chameleon</Heading>
      <Text>
        Chameleon is a library of front-end patterns, variables, and helpers that when used, will Pusherify your UI! It
        includes our colour palettes, typography, and repeated components that are used across our products.
      </Text>
      <Subheading>Quick links</Subheading>
      <Row>
        <Item
          onClick={() => {
            setCurrentSection('Colour')
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          <ItemImg src="/images/chameleon/brand-guidelines.png" alt="" />
          <ItemHeading>Colour palette</ItemHeading>
          <ItemLink>
            Find out more <CaretSVG />
          </ItemLink>
        </Item>
        <Item
          onClick={() => {
            setCurrentSection('Typography')
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          <ItemImg src="/images/chameleon/fonts.png" alt="" />
          <ItemHeading>Fonts</ItemHeading>
          <ItemLink>
            Find out more <CaretSVG />
          </ItemLink>
        </Item>
      </Row>
      <Row>
        <Item
          onClick={() => {
            setCurrentSection('Grids and layout')
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          <ItemImg src="/images/chameleon/grids-and-layout.png" alt="" />
          <ItemHeading>Grids and layout</ItemHeading>
          <ItemLink>
            Find out more <CaretSVG />
          </ItemLink>
        </Item>
        <Item
          onClick={() => {
            setCurrentSection('Buttons')
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          <ItemImg src="/images/chameleon/button-styles.png" alt="" />
          <ItemHeading>Button Styles</ItemHeading>
          <ItemLink>
            Find out more <CaretSVG />
          </ItemLink>
        </Item>
      </Row>
    </>
  )
}

export default Introduction

const CaretSVG = () => {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="2"
        height="8"
        rx="1"
        transform="matrix(-0.707108 -0.707106 0.707108 -0.707106 5.65625 12.3123)"
        fill="#300D4F"
      />
      <rect
        width="2"
        height="8"
        rx="1"
        transform="matrix(0.707108 -0.707106 0.707108 0.707106 4.24219 2.41278)"
        fill="#300D4F"
      />
    </svg>
  )
}
